import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { IStore } from 'reducers/index';
import { ISortModel } from 'reducers/filters/models';
import { setSort, resetSort } from 'actions/filters';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { isEmptyError } from 'utilities/validate';
import { setSortForTable } from 'utilities/tables';
import { GeneralTable } from 'modules/search/components/GeneralTable';
import { ExtraDocumentConfigurationColsImport, ExtraDocumentConfigurationColsExport } from './models';
import { IFeatureToggleModel } from 'reducers/featureToggle/models';
import { INickname } from 'reducers/nickname';
import { ModalScreen } from 'components/modal-screen';
import { ModalType } from 'components/modal-screen/ModalType';
import { extraDocumentCreationExport, extraDocumentCreationImport } from 'actions/extraDocument';
import moment from 'moment';
import { DateInput } from 'components/date-input';
import InPageDialog from 'components/page-dialog';

interface IExtraDocConfigDialogProps {
    closeModal: (data?: any) => void;
    submitData: (data?: any) => void;
    selectedRows: (data?: any) => void;
    selectedData: any;
    currentUser: INickname;
    documentType: string;
    showModal: boolean;
    selectedChildRows: [] | any;
}

interface IMapDispatchToProps {
    extraDocumentCreationImport: (pageNumber: number, pageSize: number, genericFilter: {}) => Promise<void>;
    extraDocumentCreationExport: (pageNumber: number, pageSize: number, genericFilter: {}) => Promise<void>;
    setSort: (sort: ISortModel) => void;
    resetSort: () => void;
}

interface IMapStateToProps {
    isFetchSearchDataLoading: boolean;
    isFetchSearchDataError: boolean;
    searchPendingError: string | string[],
    extraDocumentCreationFromAPIImport: any,
    extraDocumentCreationFromAPIExport: any,
    featureToggles: IFeatureToggleModel[],
}

interface IProps extends RouteComponentProps, IMapStateToProps, IMapDispatchToProps, IExtraDocConfigDialogProps { }

interface IState {
    sorted: any[];
    page: number | undefined;
    pageSize: number;
    totalCount: number;
    isFetchinProgress: boolean;
    pendingError: any;
    extraDocumentCreationLocalData: any[],
    shouldClear: boolean;
    hasData: boolean;
    errorMsg: string | null,
    isPaginationClicked: boolean;
    inputDate: string;
    isInputDateChanged: boolean;
    disableButton: boolean;
    showDialog: boolean;
}


export class _ExtraDocumentCreation extends Component<IProps, IState>{

    public tableRef: any = React.createRef();
    public refTable:any = React.createRef();
    public date = new Date();
    public state = {
        sorted: [],
        page: 1,
        pageSize: 10,
        totalCount: 0,
        isFetchinProgress: true,
        pendingError: '',
        extraDocumentCreationLocalData: [],
        shouldClear: false,
        hasData: false,
        errorMsg: '',
        isPaginationClicked: false,
        inputDate:'',
        isInputDateChanged: false,
        disableButton: true,
        showDialog: false
    };
    constructor(props: any) {
        super(props);
    }

    public componentDidMount() {
        this.date.setDate(this.date.getDate() - 15);
        const inputInitialDate = moment(this.date).format('YYYY-MM-DD')
        this.setState({
            isFetchinProgress: false,
            inputDate: inputInitialDate,
            isInputDateChanged: false,
            showDialog: false
        })
        this.fetchReset()
    }

    public componentDidUpdate(props: IProps, state: any) {
        if(this.state.inputDate && this.state.inputDate !== state.inputDate && this.state.isInputDateChanged === true) {
            this.targetFetch()
        }
        if (this.props.isFetchSearchDataError !== props.isFetchSearchDataError) {
            this.setState({
                isFetchinProgress: false,
                errorMsg: this.props.searchPendingError.toString() ? this.props.searchPendingError.toString() : 'Request Error'
            })
        }
        if (this.props.searchPendingError !== '' && props.searchPendingError  !== this.props.searchPendingError) {
            this.setState({
                showDialog: true,
                pendingError: this.props.searchPendingError.toString()
            })
        }
        if (this.props.extraDocumentCreationFromAPIImport !== props.extraDocumentCreationFromAPIImport) {
            this.setData(this.props.extraDocumentCreationFromAPIImport.result, this.props.extraDocumentCreationFromAPIImport.page, this.props.extraDocumentCreationFromAPIImport.pageSize, this.props.extraDocumentCreationFromAPIImport.totalCount)
            this.setState({
                totalCount: this.props.extraDocumentCreationFromAPIImport.totalCount,
            })
        }
        if (this.props.extraDocumentCreationFromAPIExport !== props.extraDocumentCreationFromAPIExport) {
            this.setData(this.props.extraDocumentCreationFromAPIExport.result, this.props.extraDocumentCreationFromAPIExport.page, this.props.extraDocumentCreationFromAPIExport.pageSize, this.props.extraDocumentCreationFromAPIExport.totalCount)
            this.setState({
                totalCount: this.props.extraDocumentCreationFromAPIExport.totalCount,
            })
        }
        if (this.props.searchPendingError !== props.searchPendingError &&
            this.props.isFetchSearchDataError === true) {
            const error = isEmptyError(this.props.searchPendingError, 'Server error');
            this.setState({
                pendingError: error,
                isFetchinProgress: false,
                hasData: false
            })
        }
        if(this.props.selectedChildRows.length !== props.selectedChildRows.length){
            if(this.props.selectedChildRows.length > 0){
                this.setState({
                    disableButton: false
                })
            } else {
                this.setState({
                    disableButton: true
                })
            }
        }
    }

    public componentWillUnmount(){
        this.props.resetSort()
    }

    public clickEventHandler = () => {
        this.setState({
            isPaginationClicked: true
        })
    }
    public handleSubmit = () => {
       this.props.submitData()
    }
    public onChangeDate = (event:any) => {
        this.setState({
            inputDate: moment(event).format('YYYY-MM-DD'),
            isInputDateChanged: true
        })
     }
    public render() {
        return (
            <ModalScreen
                title={`${this.props.documentType} Extra Document Creation`}
                modalType={ModalType.l()}
                visible={this.props.showModal}
                closeModal={this.props.closeModal}
                hideSecondaryButton={false}
                secondaryButtonTitle="Cancel"
                secondaryButtonFunc={this.props.closeModal}
                primaryButtonTitle={`Create Extra ${this.props.documentType}`}
                primaryButtonFunc={this.handleSubmit}
                primaryButtonIsDisabled={this.state.disableButton}
            >
                <InPageDialog
                    showDialog={this.state.showDialog}
                    type={'error'}
                    message={this.state.pendingError}
                    isExtraDocCreation={true}
                    closeMethod={() => this.setState({showDialog: false})} />
                    
                <h4>{this.props.documentType === 'Export' ? 'ETD' : 'ETA'} Date Range</h4>
                <div className="grid-wrapper padding-bottom-large padding-top-small">
                        <div className="col-25">
                            <DateInput
                                key={this.props.documentType === 'Export' ? 'etd' : 'eta'}
                                name={this.props.documentType === 'Export' ? 'etd' : 'eta'}
                                label="From"
                                type="date"
                                onChange={this.onChangeDate}
                                value={this.state.inputDate}
                                withTime={false} />
                        </div>
                </div>
                <div id={`extra-document-creation-${this.props.documentType}`} ref={this.refTable}>
                        <GeneralTable
                            id="extra-document-creation"
                            cols={this.props.documentType === 'Export' ? ExtraDocumentConfigurationColsExport() : ExtraDocumentConfigurationColsImport()}
                            data={this.state.extraDocumentCreationLocalData}
                            pageSize={this.state.pageSize}
                            pageCount={Math.ceil(this.state.totalCount / this.state.pageSize)}
                            isLoading={this.props.isFetchSearchDataLoading}
                            fetchData={this.justFetch}
                            refFwd={this.tableRef}
                            actionCallback={async (data:any)=> this.props.selectedRows(data)}
                            clickEventHandler={()=>{ this.clickEventHandler()}}
                        />
                        </div>
                </ModalScreen>
        );
    }

    private setData = (data: any, page: number | undefined, pageSize: number, totalCount: number) => {
        localStorage.setItem('pageSize-ListTable', pageSize.toString())
        if (data && data.length) {
            data = data.map((item: any) => {
                if (item.cblNumber) {
                    item.cblNbr = item.cblNumber;
                }
                if (item.eta) {
                    item.EstimatedTimeOfArrival = moment(item.eta).format('YYYY-MM-DD');
                }
                if (item.etd) {
                    item.EstimatedTimeOfDeparture = moment(item.etd).format('YYYY-MM-DD');
                }
                return item;
            });
        }
        this.setState({
            page,
            pageSize,
            totalCount,
            isFetchinProgress: false,
            hasData: true,
            extraDocumentCreationLocalData: data
        })
    }

    private targetFetch = (page: number = this.state.page, pageSize: number = this.state.pageSize) => {
        const tempPageSize: any = localStorage.getItem('pageSize-ListTable extra-document-creation') ?
        localStorage.getItem('pageSize-ListTable extra-document-creation') : pageSize
        this.setState({
            isFetchinProgress: true,
            pageSize : tempPageSize,
            isPaginationClicked: false
        }, () => {
            if(this.props.documentType === 'Export'){
                const query = {
                    PortOfLoad: this.props.selectedData.portOfLoad,
                    OriginService: this.props.selectedData.originService,
                    DestinationService: this.props.selectedData.destinationService,
                    PlaceOfReceipt: this.props.selectedData.placeOfReceipt,
                    TransportationMode: this.props.selectedData.transportationMode,
                    Consignee: this.props.selectedData.consignee,
                    Shipper: this.props.selectedData.shipper,
                    ProductType: this.props.selectedData.productType,
                    BusinessIdentifiers:['1'],
                    ETA: this.state.inputDate,
                }
                this.props.extraDocumentCreationExport(page, tempPageSize, query)
            }
            if(this.props.documentType === 'Import'){
                const query = {
                    OriginalPortOfLoading: this.props.selectedData.portOfLoad,
                    ServiceAtOrigin: this.props.selectedData.originService,
                    ServiceAtDestination: this.props.selectedData.destinationService,
                    CarrierPlaceOfDelivery: this.props.selectedData.carrierPlaceOfDelivery,
                    ClientPlaceOfDelivery: this.props.selectedData.clientPlaceOfDelivery,
                    PlaceOfReceipt: this.props.selectedData.placeOfReceipt,
                    FinalPortOfDischarge: this.props.selectedData.portOfDischarge,
                    Consignee: this.props.selectedData.consignee,
                    ProductType: this.props.selectedData.productType,
                    ETA: this.state.inputDate,
                }
                this.props.extraDocumentCreationImport(page, tempPageSize, query)
            }
        })
    }
    private fetchReset = (page: number = 1, pageSize: number = 10) => {
            const p = this.state.page ? this.state.page : page;
            const pS = this.state.pageSize ? this.state.pageSize : pageSize;
            this.setState({
                page: p,
                pageSize: pS,
            });
            this.targetFetch(p, pS)
    };
    private justFetch = (tableData: any) => {
        if (!this.state.isFetchinProgress) {
            let props = {
                page: this.state.page,
                pageSize: this.state.pageSize
            }
            if (tableData) {
                if(tableData && tableData.sorted && tableData.sorted.length > 0 && (tableData.sorted[0].id === 'rateErrorMessage' || tableData.sorted[0].id === 'agedTime') ){
                    this.setState({ isFetchinProgress: false});
                    return
                }
                props = {
                    page: tableData.page + 1,
                    pageSize: tableData.pageSize
                }
                this.setState({ sorted: tableData.sorted });
                setSortForTable(tableData.sorted, this.props.setSort)
            } else if (this.state.sorted && this.state.sorted.length) {
                setSortForTable(this.state.sorted, this.props.setSort);
            }
            this.setState({
                page: props.page,
                pageSize: props.pageSize,
            });
            if(this.state.isPaginationClicked){
                if(this.state.page !== tableData.page+1 || this.state.sorted !== tableData.sorted){
                    this.setState({
                        isFetchinProgress: true
                    });
                    this.targetFetch(tableData.page+1, props.pageSize)
                }
            } else {
                if(tableData.pageSize !== this.state.pageSize) {
                    this.setState({
                        page: 1,
                        pageSize: tableData.pageSize
                    });
                    this.targetFetch(1, tableData.pageSize)
                }else {
                    this.targetFetch(tableData.page+1, props.pageSize)
                }
            }
        }
        if (tableData) {
            this.setState({
                page: tableData.page + 1,
                pageSize: tableData.pageSize,
            })
        }
    };
}
const mapStateToProps = (state: IStore): IMapStateToProps => ({
    isFetchSearchDataLoading: state.extraDocument.isFetchDataLoading,
    isFetchSearchDataError: state.extraDocument.isFetchDataError,
    searchPendingError: state.extraDocument.pendingError,
    extraDocumentCreationFromAPIImport: state.extraDocument.extraDocumentCreationImport,
    extraDocumentCreationFromAPIExport: state.extraDocument.extraDocumentCreationExport,
    featureToggles: state.featureToggle.featureToggles,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatchToProps => ({
    extraDocumentCreationImport: (pageNumber: number, pageSize: number, genericFilter: string) => dispatch(extraDocumentCreationImport(pageNumber, pageSize, genericFilter)),
    extraDocumentCreationExport: (pageNumber: number, pageSize: number, genericFilter: string) => dispatch(extraDocumentCreationExport(pageNumber, pageSize, genericFilter)),
    setSort: (sort: ISortModel) => dispatch(setSort(sort)),
    resetSort: () => dispatch(resetSort()),
});
const __SearchD = connect<IMapStateToProps, IMapDispatchToProps, {}, IStore>(mapStateToProps, mapDispatchToProps)(_ExtraDocumentCreation);
export const ExtraDocumentCreation = withRouter(__SearchD);